export const getBSInfantMeatsPackage = newProduct => {
  let newBSInfantMeatsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newBSInfantMeatsPackage.MultiPackageCount = newProduct.MultiPackageCount
  }
  return newBSInfantMeatsPackage
}
export const updateBSInfantMeatsPackage = newProduct => {
  let newBSInfantMeatsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newBSInfantMeatsPackage.MultiPackageCount = newProduct.MultiPackageCount
  }
  return newBSInfantMeatsPackage
}
